// MSAL / Microsoft Entra auth
/**
 * Azure DevOps resource app ID (well-known, constant). `.default` requests every
 * delegated permission the Entra app registration has been consented for.
 * https://learn.microsoft.com/en-us/azure/devops/integrate/get-started/authentication/entra-oauth
 */
export const ADO_SCOPES = ['499b84ac-1321-427f-aa17-267ca6975798/.default'];
/** Multi-tenant work/school accounts: each customer signs into their own tenant. */
export const AZURE_AUTHORITY = 'https://login.microsoftonline.com/organizations';
/** sessionStorage clears on tab close; we never persist a long-lived token. */
export const AZURE_TOKEN_CACHE_LOCATION = 'sessionStorage' as const;

// Accounts (organizations) lookup
export const ACCOUNTS_URL = 'https://app.vssps.visualstudio.com/_apis/accounts';
export const ACCOUNTS_API_VERSION = '6.0';

// Work-item creation
export const BYPASS_RULES_QUERY_PARAM = 'bypassRules';
export const BYPASS_RULES_QUERY_VALUE = 'true';

// Issue-creator UI
export const ADD_TO_AZURE_LABEL = 'Add to Azure';
export const ALERT_POPUP_TITLE = 'Connect to Azure';
export const ISSUE_FORM_TITLE = 'Create Issue in Azure';
export const AZURE_NOT_CONNECTED_MESSAGE = 'Azure is not connected';
export const OK_BUTTON_TITLE = 'OK';
export const FIELDS_TO_IGNORE = ['Iteration ID', 'Area ID'];
